export const capitalizeWord = string => string.charAt(0).toUpperCase() + string.toLowerCase().slice(1);
